export default "__VITE_ASSET__DU1sqVdg__"